const enum GearFilter {
  All = 'all',
  Tent = 'tent',
  SleepingBag = 'sleeping_bag',
  Backpack = 'backpack',
  Clothing = 'clothing',
  Mat = 'mat',
  Furniture = 'furniture',
  Lantern = 'lantern',
  Cooking = 'cooking',
  Electronic = 'electronic',
  Food = 'food',
  Etc = 'etc',
}

export default GearFilter;
